module.exports = __webpack_public_path__ + "static/banner-d5d490aac71867f430cdeed9e791592a.png";